import type { JSX } from 'react'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

export interface DisconnectConfirmDialogProps {
  visible: boolean
  displayName: string
  pending: boolean
  onCancel: () => void
  onConfirm: () => void
}

export default function DisconnectConfirmDialog(props: DisconnectConfirmDialogProps): JSX.Element {
  return (
    <Dialog
      visible={props.visible}
      onHide={props.onCancel}
      header={`Disconnect ${props.displayName}`}
      style={{ width: '32rem' }}
      modal
    >
      <div className="space-y-3 text-sm">
        <p>
          {'Disconnect '}<strong>{props.displayName}</strong>?
        </p>
        <p className="text-gray-700">
          Inbound webhooks will stop and outbound sends will be rejected. Existing conversations remain
          in the system; only this channel connection is removed. You can reconnect at any time.
        </p>
        <div className="mt-4 flex justify-end gap-2">
          <Button label="Cancel" onClick={props.onCancel} disabled={props.pending} />
          <Button label="Disconnect" onClick={props.onConfirm} disabled={props.pending} />
        </div>
      </div>
    </Dialog>
  )
}
